import { public_key, url_public_key, crypto_public_key } from './card_payment_keys';
import CryptoJS from "crypto-js";
const NodeRSA = require('node-rsa');
const Cryptr = require('cryptr');
const cryptr = new Cryptr(url_public_key);

export const Encrypt = (object, callback) => {
  const key_public = new NodeRSA({ b: 1024 });
  key_public.importKey(public_key);
  key_public.setOptions({
    environment: 'browser',
    encryptionScheme: 'pkcs1'
  });
  let encryptedValue = key_public.encrypt(object, 'base64')
  if (encryptedValue != null) {
    let payLoad = { encryptedCardDetails: encryptedValue }
    callback(payLoad);
  }
}

export const EncryptCommon = (object, callback) => {
  const key_public = new NodeRSA({ b: 1024 });
  key_public.importKey(public_key);
  key_public.setOptions({
    environment: 'browser',
    encryptionScheme: 'pkcs1'
  });
  let encryptedValue = key_public.encrypt(object, 'base64')
  if (encryptedValue != null) {
    callback(encryptedValue);
  }
}

export const URLEncrypt = (url, callback) => {
  var encryptedURL = cryptr.encrypt(url);
  callback(encryptedURL);
}

export const URLDecrypt = (url, callback) => {
  var decryptedURL = cryptr.decrypt(url);
  callback(decryptedURL);
}

export const EncryptString = (text) => {

    let key = CryptoJS.enc.Utf8.parse(crypto_public_key);
    const encryptedString = CryptoJS.AES.encrypt(
      JSON.stringify(text),
      key,
      {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}
    ).toString();

    return encryptedString;
}

export const Decrypt = (encryptedText) => {
  let key = CryptoJS.enc.Utf8.parse(crypto_public_key);
  const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString);
}